import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//

import { pro, setting } from '@/utils/settings';
import { getCurrentProInfo } from '@/utils';
import { Base64 } from 'js-base64';
// import ResizeMixin from '@/layout/mixin/ResizeHandler'

export default {
  name: 'App',
  data: function data() {
    return {
      loading: null,
      lastTime: null,
      // 鼠标最后一次点击时间
      timeOut: 1500 * 60 * 1000 // 未检测到鼠标点击就退出
    };
  },
  // mixins: [ResizeMixin],
  mounted: function mounted() {
    this.lastTime = new Date().getTime();
    this.getThemes();
    this.handleAutoLogin();
  },
  methods: {
    handleAutoLogin: function handleAutoLogin() {
      var _this = this;
      this.$nextTick(function () {
        var code = _this.Utils.getUrlKey('code');
        var token = _this.Utils.getUrlKey('token');
        var isOutLogin = _this.Utils.getUrlKey('isOutLogin');
        if (Number(code) === 200 && token && isOutLogin === '2') {
          _this.openFullScreen();
          // const parmurls = window.location.href.split(process.env.NODE_ENV == 'development' ? '/?' : '/home')[0]
          var parmurls = window.location.href.split('/?')[0];
          // const env = process.env.NODE_ENV == 'development' ? '' : '/home'
          var env = '';
          var jumpUrl = "".concat(parmurls).concat(env).concat(Base64.decode(_this.Utils.getUrlKey('jumpUrl')));
          _this.$store.dispatch('user/setToken', {
            token: token
          }).then(function () {
            _this.$store.dispatch('user/getInfo', {
              token: token
            }).then(function () {
              _this.timer = setTimeout(function () {
                window.location.href = jumpUrl;
                _this.loading.close();
                _this.$notify({
                  title: '欢迎',
                  message: '欢迎回来',
                  type: 'success'
                });
              }, 2000);
            })["catch"](function (err) {
              _this.$router.push("/login");
            });
          })["catch"](function (err) {
            var msg = ((err.response || {}).data || {}).msg || err.msg || '服务器异常，请稍后再试';
            _this.$notify.error({
              title: '错误',
              message: msg
            });
          });
        }
      });
    },
    // 加载效果
    openFullScreen: function openFullScreen() {
      this.loading = this.$loading({
        lock: true,
        text: '系统数据加载中......',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
        customClass: 'customClass'
      });
    },
    isTimeOut: function isTimeOut() {
      var _this2 = this;
      if (process.env.NODE_ENV == 'development') return;
      var currentTime = new Date().getTime();
      if (currentTime - this.lastTime > this.timeOut) {
        if (this.$ls.get('ACCESS_TOKEN')) {
          // 如果是登录状态
          this.$store.dispatch('user/logout').then(function () {
            _this2.$message.warning('太久没有操作，请重新登录！');
            setTimeout(function () {
              _this2.$router.push('/');
            }, 1500);
          });
        } else {
          this.lastTime = new Date().getTime();
        }
      } else {
        this.lastTime = new Date().getTime();
      }
    },
    // 设置各个学校特有的颜色
    getThemes: function getThemes() {
      var themeColors = getCurrentProInfo(pro, setting).themeColors;
      document.getElementsByTagName('body')[0].style.setProperty('--bg-color', themeColors.$bg);
      document.getElementsByTagName('body')[0].style.setProperty('--gradation-color', themeColors.$gradationColor);
      document.getElementsByTagName('body')[0].style.setProperty('--tint-color', themeColors.$tintColor);
    }
  }
};